import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface BasicDatePickerProps {
  label?: string;
  name?: string;
  value: any;
  onChange: (date: any) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  sx?: any;
  margin?: 'none' | 'normal' | 'dense';
}

export default function BasicDatePicker({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  required,
  disabled,
  sx,
  margin = 'normal'
}: BasicDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
        slotProps={{
          textField: {
            error,
            required,
            margin,
            name,
            disabled,
            fullWidth: true,
            helperText: helperText || undefined,
          }
        }}
        sx={{
          width: '100%',
          '& .MuiInputBase-root': {
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: 'error.main',
            }
          },
          ...sx
        }}
      />
    </LocalizationProvider>
  );
}
